import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './crm.utils.slice';

const crmCreatorSelects = (state) => state.creator_association || initialState;

export const selectSelectedCreators = createSelector(
	[crmCreatorSelects],
	(state) => state.selectedCreators,
);
